<script>
  import { getTrendingFeedData, getVideoById } from "@/api";
  import InstallBanner from "@/components/molecules/InstallBanner.svelte";
  import VideoItemHead from "@/components/molecules/VideoItemHead.svelte";
  import FeedWrapper from "@/components/organisms/FeedWrapper.svelte";
  import constants from "@/constants";
  import { VIDEO_FEED_BLOCK } from "@/constants/constants";
  import trendingFeedStore from "@/stores/trendingFeed";
  import { fetchVideoList, shouldCallFeedApi } from "@/utils/experimentUtils";
  import { getLocalStorageWithExpiration } from "@/utils/helpers/utils.js";
  import { toggleLikeCountVideoFeed } from "@/utils/index.js";
  import { goto } from "@/utils/navigationUtils";
  import { onMount } from "svelte";

  const { NOT_FOUND_URL, NO_MORE_POSTS_OFFSET } = constants;

  export let data;
  let list = [];
  let currentIndex = 0;
  let feedOffset;
  let isFeedApiBusy = false;
  export let {
    item,
    videoId,
    isSocialProofingVariant,
    isPlayThumbnailVariant,
  } = data;
  $: hasData = typeof item === "object" && !!item;
  $: showInstallBanner = true;
  $: {
    const feedData = $trendingFeedStore;
    list = [item, ...(feedData?.list ?? [])];
    feedOffset = feedData.offset;
  }

  const toggleInstallBanner = (flag) => {
    showInstallBanner = flag;
  };
  const fetchFeedData = (reducerAction) =>
    getTrendingFeedData(window.fetch, reducerAction);

  onMount(async () => {
    try {
      if (!hasData) {
        item = await getVideoById(window.fetch, videoId);
      }

      // Concat Data for Infinite Scroll Feed
      if (shouldCallFeedApi()) {
        await fetchFeedData("concat");
      } else {
        list = [""];
      }
      list = fetchVideoList(list);
      if (item && (item.isDeleted || item.err)) {
        await goto(NOT_FOUND_URL);
      }
    } catch (e) {
      console.warn(e);
    }
  });
  const hasMorePosts = () => feedOffset !== NO_MORE_POSTS_OFFSET;
  const toggleLikeCount = (action, index) => {
    list = toggleLikeCountVideoFeed(list, action, index);
  };
  const onSwipe = async (activeIndex) => {
    currentIndex = activeIndex;
    if (
      list.length - currentIndex < 3 &&
      hasMorePosts() &&
      !isFeedApiBusy &&
      !getLocalStorageWithExpiration(VIDEO_FEED_BLOCK.BLOCK_VIDEO_FEED)
    ) {
      isFeedApiBusy = true;
      await fetchFeedData("concat");
      list = fetchVideoList(list);
      isFeedApiBusy = false;
    }
  };
</script>

<main>
  {#if hasData}
    <VideoItemHead
      {item}
      {videoId}
      {isSocialProofingVariant}
      {isPlayThumbnailVariant}
    />
    <div class="swipe-holder">
      <FeedWrapper
        {onSwipe}
        {currentIndex}
        {list}
        {toggleLikeCount}
        {toggleInstallBanner}
        {showInstallBanner}
      />
      {#if list && list.length > 0 && showInstallBanner}
        <InstallBanner source: VIDEO_FEED_SOURCE.TRENDING_FEED />
      {/if}
    </div>
  {/if}
</main>
